import { Injectable } from '@angular/core';
import {
  AuthService,
  BaseViewConfigService,
  Product,
  ProductExportActionConfigService,
  ProductExportListConfigService,
  ProductExportService,
  ProductExportTableComponent,
  ProductListV2ConfigService,
  ProductService,
  ProductSortService
} from 'gung-standard';
import { GridLayoutComponent, ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { CultProductExportCardComponent } from '../components/cult-product-export-card/cult-product-export-card.component';
import { CultProductListConfigService } from './cult-product-list-config.service';
import { CultArQEliassonArtnrFilter } from './cult-product-list-v2-config.service';

@Injectable({
  providedIn: 'root'
})
export class CultProductExportListConfigService extends ProductExportListConfigService {
  constructor(
    protected authService: AuthService,
    protected productExportService: ProductExportService,
    protected productSortService: ProductSortService,
    protected productService: ProductService,
    protected productListConfigService: CultProductListConfigService,
    protected productExportActionConfigService: ProductExportActionConfigService,
    protected productListV2ConfigService: ProductListV2ConfigService,
    protected baseViewConfigService: BaseViewConfigService
  ) {
    super(
      productService,
      authService,
      productExportService,
      productSortService,
      productListConfigService,
      productExportActionConfigService,
      productListV2ConfigService,
      baseViewConfigService
    );
  }

  getLayouts(): ListLayout<Product>[] {
    return [
      {
        getIconClass: () => 'fas fa-th',
        getListItemComponent: () => CultProductExportCardComponent,
        getListLayoutComponent: () => GridLayoutComponent,
        getName: () => 'ProductGrid'
      },
      {
        getIconClass: () => 'fas fa-list',
        getListItemComponent: () => ProductExportTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'ProductList'
      }
    ];
  }

  getBatchSizes() {
    return this.productListConfigService.getBatchSizes();
  }

  hideZeroOptions() {
    return this.productListConfigService.hideZeroOptions();
  }

  getFilters() {
    return [...super.getFilters(), , new CultArQEliassonArtnrFilter()];
  }
}
